import React from 'react'
import _ from 'lodash'
import { config } from 'config'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import { prefixLink } from 'gatsby-helpers'
import profilePic from './profile-pic.jpg'
import styles from './PortfolioHead.module.scss'

class PortfolioHead extends React.Component {

  static propTypes () {
    return {
      data: React.PropTypes.object,
    }
  }

  render () {
    const data = this.props.data;
    const linearTint = 'linear-gradient(rgba(57, 61, 81, 0.75), rgba(57, 61, 81, 0.75))';
    const cover = data.cover || '/images/default-splash.jpg';
    console.log(data);
    const haveLink = !_.isUndefined(data.site) || !_.isUndefined(data.appStoreLink);
    console.log(haveLink);
    const splashContainerStyle = {
      background: `${linearTint}, url("${cover}") center center / cover no-repeat`
    };

    return (
      <div className={styles.portfolioHead}>
        <div className={styles.splash} style={splashContainerStyle}>
          <Container
            style={{
              maxWidth: 1170,
              padding: `${rhythm(5)} ${rhythm(3/4)}`,
            }}
          >
            <a href="/works/">WORKS <span className="text-malibu">/</span></a>
            <h1>{data.name}</h1>
            <p>{data.description}</p>
          </Container>
        </div>
        <div className={styles.infoBanner}>
          <Container
              style={{
                maxWidth: 1170,
                paddingTop: 0,
                padding: `${rhythm(1)} ${rhythm(3/4)}`,
              }}
            >
            <Grid columns={12} className="navbar">

              <Breakpoint minWidth={700} widthMethod="componentWidth">
                <Span columns={6}>
                  {data.for && 
                    <div>
                      <h3>
                        <span className={styles.label}>For:</span><br />
                        <span className={styles.field}>{data.for}</span>
                      </h3>
                      
                    </div>
                  }
                  {data.client && 
                    <div>
                      <h3>
                        <span className={styles.label}>Client:</span><br />
                        <span className={styles.field}>{data.client}</span>
                      </h3>
                      
                    </div>
                  }
                  {data.competition && 
                    <div>
                      <h3>
                        <span className={styles.label}>Competition:</span><br />
                        <span className={styles.field}>{data.competition}</span>
                      </h3>
                      
                    </div>
                  }
                  {data.awards && 
                    <div>
                      <h3>
                        <span className={styles.label}>Awards:</span><br />
                        <span className={styles.field}>{data.awards}</span>
                      </h3>
                      
                    </div>
                  }
                </Span>
                <Span columns={3}>
                  <h3>
                    <span className={styles.label}>Role:</span><br />
                    <span className={styles.field}>{data.role}</span>
                  </h3>
                </Span>      
                <Span columns={3} last>
                  <h3>
                    <span className={styles.label}>When:</span><br />
                    <span className={styles.field}>{data.time}</span>
                  </h3>
                  
                  {haveLink &&
                    <div>
                      <h3>
                        <span className={styles.label}>Link:</span><br />
                        <span className={styles.field}>
                          {data.site && 
                            <div><a href={data.site}>{data.site}</a></div>
                          }
                          {data.appStoreLink && 
                            <div><a href={data.appStoreLink}>AppStore</a></div>
                          }
                        </span>
                      </h3>
                    </div>
                  }
                </Span>
              </Breakpoint>

              <Breakpoint maxWidth={700} widthMethod="componentWidth">
                <Span columns={12}>
                  {data.for && 
                    <div>
                      <h3>
                        <span className={styles.label}>For:</span><br />
                        <span className={styles.field}>{data.for}</span>
                      </h3>
                      
                    </div>
                  }
                  {data.client && 
                    <div>
                      <h3>
                        <span className={styles.label}>Client:</span><br />
                        <span className={styles.field}>{data.client}</span>
                      </h3>
                    </div>
                  }
                  {data.competition && 
                    <div>
                      <h3>
                        <span className={styles.label}>Competition:</span><br />
                        <span className={styles.field}>{data.competition}</span>
                      </h3>
                    </div>
                  }
                  {data.awards && 
                    <div>
                      <h3>
                        <span className={styles.label}>Awards:</span><br />
                        <span className={styles.field}>{data.awards}</span>
                      </h3>
                      
                    </div>
                  }
                  
                  <h3>
                    <span className={styles.label}>When:</span><br />
                    <span className={styles.field}>{data.time}</span>
                  </h3>
                  

                  <h3>
                    <span className={styles.label}>Role:</span><br />
                    <span className={styles.field}>{data.role}</span>
                  </h3>
                  

                  {haveLink &&
                    <div>
                      <h3>
                        <span className={styles.label}>Link:</span><br />
                        <span className={styles.field}>
                          {data.site && 
                            <div><a href={data.site}>{data.site}</a></div>
                          }
                          {data.appStoreLink && 
                            <div><a href={data.appStoreLink}>AppStore</a></div>
                          }
                        </span>
                      </h3>
                    </div>
                  }
                </Span>
              </Breakpoint>

            </Grid>
          </Container>  
        </div>   
      </div>
    )
  }
}

export default PortfolioHead



/** WEBPACK FOOTER **
 ** ../components/PortfolioHead.js
 **/